<template>
  <div id="zwant">
    <ul class="flex-box">
      <li class="relativeItem" v-for="(n,index) in 12" :key="index">
        <router-link to="/zgdetail" class="allA"></router-link>
        <div class="img relativeItem">
          <img class="absoluteItem centerImg" src="../../assets/blankimgcover.jpg" />
        </div>
        <p class="name">杏仁 十年老店巴旦木500g 手剥巴旦木</p>
        <p class="p flex-box">
          <span class="price">
            <i>￥</i>200.00
          </span>
          <span class="num">50人想买</span>
        </p>
      </li>
    </ul>

    <!--空白提示-->
    <!-- <div class="blank">
      <img src="../../assets/blankimgcover.jpg" />
      <p>空列表</p>
    </div> -->

  </div>
</template>

<script>


export default {
  name: "zwant",
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted: function() {
    this.$tool.setTitle("新增");
  },
};
</script>








<style scoped>
ul {
  padding: 16px;
  justify-content: space-between;
  flex-wrap: wrap;
}
li {
  width: 48%;
  margin-bottom: 6px;
  background: white;
  border-radius: 8px;
}
.name {
  font-size: 16px;
  text-align: justify;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.img {
  width: 100%;
  height: 167px;
  overflow: hidden;
  border-radius: 8px;
}
li p{
  padding: 0 3px;
}
.name {
  margin-top: 7px;
  margin-bottom: 17px;
  height:42px;
}
.p{
  margin-bottom: 3px;
  justify-content: space-between;
  align-items: flex-end;
}
.price i {
  font-style: normal;
  font-size: 13px;
}
.price {
  color: #ff6161;
  font-size: 18px;
}
.num {
  font-size: 14px;
  color: #999;
  /* float: right; */
}
.allA{
  z-index: 1;
}


.blank{
  text-align: center;
}
.blank img{
  width: 120px;
  margin: 0 auto;
  margin-top: 20%;
  margin-bottom: 10px;
}
.blank p{
  font-size: 14px;
  color: #999;
}
</style>
